import React from 'react';
import ScannerShell from '../Scanner/components/ScannerShell';

const ScannerUsb = () => <ScannerShell inputMode="usb" />;

export default ScannerUsb;
